module.exports = __webpack_public_path__ + "img/张家顺@2x.5c921967.png";